import React, { useState } from 'react';
import './index.scss';
import { Modal, Form, Input, Button } from 'antd';
import raysserveapi from '@/api/raysserveapi';
import { regs } from '@/utils/formValidations';

export default function ContactModal(props) {

  const { open, onCancel } = props;
  const [loading, setLoading] = useState(false);
  const [contactSuccess, setContactSuccess] = useState(false);

  const onFinish = async values => {
    setLoading(true);
    raysserveapi.addAiCustomerMsg(values).then(res => {
      setContactSuccess(true);
      setLoading(false);
    });
  };

  return (
    <Modal
      className={contactSuccess ? 'ai_book-contactSuccess' : 'ai_book-contact'}
      open={open}
      width={contactSuccess ? 480 : 600}
      onCancel={() => {
        setContactSuccess(false);
        onCancel();
      }}
      footer={null}
      centered
      destroyOnClose
    >
      {
        contactSuccess &&
        <div className="contactSuccess">
          <img src="https://oss.5rs.me/oss/uploadfe/png/75716ce453ddeb5fbb5360fc78a8a681.png" />
        </div>
      }
      {
        !contactSuccess &&
        <>
          <h3 className="form-title">填写下方资料，我们将尽快跟您联系</h3>
          <Form
            className="account-wrap"
            autoComplete="off"
            onFinish={onFinish}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Form.Item
              label="姓名"
              name="name"
              rules={[
                { required: true, message: '请输入姓名' }
              ]}
            >
              <Input maxLength={50} className="input-wrap" autoComplete="off" placeholder="请输入真实姓名" />
            </Form.Item>
            <Form.Item
              label="出版社"
              name="publisher"
              rules={[
                { required: true, message: '请输入出版社' }
              ]}
            >
              <Input className="input-wrap" autoComplete="off" placeholder="请输入出版社" />
            </Form.Item>
            <Form.Item
              label="手机"
              name="phone"
              rules={[
                { required: true, message: '请输入手机号' },
                { pattern: regs.mobile, message: '请输入正确的手机号' }
              ]}
            >
              <Input
                className="input-wrap"
                autoComplete="off"
                type="number"
                placeholder="请输入手机号"
              />
            </Form.Item>
            <Form.Item
              label="邮箱"
              name="email"
              rules={[
                { pattern: regs.email, message: '请输入正确的邮箱' }
              ]}
            >
              <Input
                className="input-wrap"
                autoComplete="off"
                placeholder="请输入邮箱"
              />
            </Form.Item>
            <Form.Item
              label="留言"
              name="leaveWord"
            >
              <Input.TextArea maxLength={200} className="input-wrap input-wrap-area" placeholder="请输入留言" rows={5} />
            </Form.Item>
            <Form.Item className="mb0">
              <Button size="large" className="submit-btn" type="primary" loading={loading} htmlType="submit" block>提交</Button>
            </Form.Item>
          </Form>
        </>
      }
    </Modal>
  );
}